import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CheckoutProgressionStepsComponent } from '@checkout/feature-components';
import { BasketSummaryComponent } from '@domgen/dgx-fe-basket';
import { CmsArea } from '@domgen/dgx-fe-cms';
import {
  ButtonComponent,
  ButtonGroupComponent,
  ButtonLinkComponent,
  ButtonNavigateBackComponent,
  ButtonTextComponent,
} from '@domgen/dgx-fe-components/button';
import { CardComponent } from '@domgen/dgx-fe-components/card';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { FormSubmitButtonComponent } from '@domgen/dgx-fe-forms/layout';
import { GAPage } from '@domgen/dgx-fe-ga';
import { TranslatePipe } from '@domgen/dgx-fe-i18n';
import { EditableArea } from '@magnolia/angular-editor';
import { PersonalDetailsFormComponent } from '../../components/personal-details-form/personal-details-form.component';
import { PersonalDetailsComponentService } from '../../services/personal-details-component/personal-details-component.service';

@Component({
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    BasketSummaryComponent,
    ButtonComponent,
    ButtonGroupComponent,
    ButtonLinkComponent,
    ButtonNavigateBackComponent,
    ButtonTextComponent,
    CardComponent,
    CheckoutProgressionStepsComponent,
    EditableArea,
    FormSubmitButtonComponent,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
    NgTemplateOutlet,
    PersonalDetailsFormComponent,
    TranslatePipe,
  ],
  providers: [PersonalDetailsComponentService],
})
@GAPage()
export class PersonalDetailsComponent {
  @Input() main!: CmsArea;

  constructor(readonly cs: PersonalDetailsComponentService) {}
}
